import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../actions";
import { ADD_FLEET_AUTH_RESPONSE } from "../../../constants/action_types";
import { getValueFromNestedObject } from "../../../util/operations/helper";
import { Banner } from "flowbite-react";
import FleetSetupModal from "./zuper_fleet/setup_modal";

function ZuperFleet({ company_uid }) {
  const dispatch = useDispatch();
  const [showSetupModal, setShowSetupModal] = useState(false);

  const currentPolicy = useSelector((state) => state.company.policy);
  const companyUpdate = useSelector((state) => state.company.update_response);

  const isConnected = getValueFromNestedObject(currentPolicy, "zuper_fleet.is_connected");

  useEffect(() => {
    dispatch(actions.GETCOMPANYPOLICY_REQ({ company_uid }));
  }, [company_uid]);

  useEffect(() => {
    if (companyUpdate.type === ADD_FLEET_AUTH_RESPONSE) {
      setShowSetupModal(false);
    }
  }, [companyUpdate]);

  return (
    <>
      <div className="h-full mt-3 rounded-lg">
        <div className="relative h-full w-full bg-white rounded-lg shadow">
          <div className="flow-root">
            <div className="mx-auto pb-3 border-b sm:flex sm:items-center sm:justify-between py-4 bg-white z-10 sm:px-6 lg:px-8 shadow rounded-t-lg">
              <h3 className="text-lg font-semibold leading-6 text-gray-900">
                Zuper Fleet
              </h3>
            </div>
            <div className="inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
              {currentPolicy && (isConnected ? (
                <Banner className="mb-4">
                  <div className="flex w-full justify-between border-green-200 bg-green-50 p-3 rounded-lg">
                    <div className="mx-auto flex items-center">
                      <p className="flex items-center text-md font-normal text-green-600 dark:text-green-400">
                        <span className="[&_p]:inline">
                          Zuper Fleet is connected to Azuga account
                        </span>
                      </p>
                    </div>
                  </div>
                </Banner>
              ) : (
                <Banner className="mb-4">
                  <div className="flex w-full justify-between border-red-200 bg-red-50 p-3 rounded-lg">
                    <div className="mx-auto flex items-center">
                      <p className="flex items-center text-md font-normal text-red-500 dark:text-red-400">
                        <span className="[&_p]:inline">
                          Zuper Fleet is not yet connected to Azuga account
                        </span>
                      </p>
                    </div>
                    <button
                      className="inline-flex items-center justify-center border-1 bg-red-600 text-gray-50 hover:bg-red-700 shadow hover:shadow-inner px-3 py-1 rounded-lg"
                      onClick={() => setShowSetupModal(true)}
                    >
                      <span className="text-sm font-medium">Setup</span>
                    </button>
                  </div>
                </Banner>
              ))}
            </div>
          </div>
        </div>
      </div>

      <FleetSetupModal
        company_uid={company_uid}
        isOpen={showSetupModal}
        onClose={() => setShowSetupModal(false)}
      />
    </>
  );
}

export default ZuperFleet;
